<template>
    <div>
        <additional-email 
            v-for="(email, index) in emails" 
            :key="index"
            v-model="emails[index]" 
            :user-id="userId"
            @cancel="removeEmail"
            @make-email-primary="makeEmailPrimary"></additional-email>
        <button @click.prevent="addNewEmail()">Add secondary email address</button>
    </div>
</template>

<script>
import { validateEmail } from '@/helper/email';
import AdditionalEmail from './AdditionalEmail.vue';

export default {
    name: 'AdditionalEmails',
    components: {
        AdditionalEmail
    },
    props: {
        value: Array,
        userId: String,

    },
    data() {
        return {
            emails: []
        };
    },
    computed: {
        isValid() {
            return this.emails.every(email => {
                return validateEmail(email.address);
            });
        }
    },
    methods: {
        addNewEmail() {
            this.emails.push({
                id: null,
                address: '',
                verified: false
            });
        },
        removeEmail(email) {
            this.emails = this.emails.filter(existingEmail => {
                return existingEmail.address !== email.address;
            });
        },
        makeEmailPrimary(email) {
            this.$emit('make-email-primary', email);
        },
    },
    watch: {
        emails: {
            deep: true,
            handler(newValue) {
                this.$emit('input', newValue);
            }
        },
        isValid(value) {
            this.$emit('validate', value);
        }
    },
    mounted() {
        this.emails = this.value;
    }
}
</script>
